import { render, staticRenderFns } from "./DesignPreview.vue?vue&type=template&id=07873628&"
import script from "./DesignPreview.vue?vue&type=script&lang=js&"
export * from "./DesignPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports